<template>
  <div class="general-layout">
    <router-view class="view-container" />
  </div>
</template>

<script>
export default {
  name: "GeneralLayout",
};
</script>

<style lang="scss" scoped>
.general-layout {
  min-height: 100%;
  min-width: 100vw;
  .view-container {
    margin: 20px 20px 20px var(--nav-side-pc-width);
    min-height: 680px;
    @media screen and (max-width: 1199px) {
      margin: 20px 20px 20px var(--nav-side-tablet-width);
    }
  }
}
</style>